module.exports = __webpack_public_path__ + "img/KSC05586.0c436505.jpg";